/*
 * Scentered cart drawer helpers.
 * - Opens Modular's cart drawer after any successful add to cart (theme forms,
 *   quick view, Section Store "Add" buttons, in-cart suggestions), instead of the popover.
 * - One-tap add for in-cart suggestions ([data-sc-rec-add]).
 * - Saves the gift message from inside the drawer (the inline script in
 *   gift-wrap.liquid does not run when the drawer is cloned from its <template>).
 * Trade customers (window.scTrade) get the wholesale app's Trade cart instead of the drawer.
 * Loaded after theme.js (both deferred), so window.cart already exists.
 */
(function () {
  'use strict';

  var onCartPage = /^\/cart\/?$/.test(window.location.pathname);

  // "Goes well with" (Section Store upsell block) draws its "+ Add" buttons inside a shadow root,
  // so sc-brand.css can't reach them. Give them the site's peppermint button with slate text.
  var upsellCss = 'button{background-color:#b6d2c0!important;border-color:#b6d2c0!important;color:#3d4c53!important}' +
    'button:hover{background-color:#a3c5af!important}button *,button svg{color:#3d4c53!important;fill:#3d4c53!important}';
  function styleUpsellBlocks() {
    document.querySelectorAll('section-store--upsell-block').forEach(function (block) {
      if (!block.shadowRoot || block.shadowRoot.querySelector('style[data-sc-brand]')) return;
      var style = document.createElement('style');
      style.setAttribute('data-sc-brand', '');
      style.textContent = upsellCss;
      block.shadowRoot.appendChild(style);
    });
  }
  if (window.customElements && document.querySelector('section-store--upsell-block')) {
    window.customElements.whenDefined('section-store--upsell-block').then(function () {
      // The block renders after it loads its products; keep checking for a few seconds.
      var tries = 0;
      (function retry() {
        styleUpsellBlocks();
        if (++tries < 20) setTimeout(retry, 250);
      })();
    });
  }

  // Benefits band on product pages: give each label half its one-line width so every label breaks
  // into two even lines (Lara, 3 Nov: "All-natural formula" on one line next to two-line labels looked unbalanced).
  function balanceBenefitLabels() {
    document.querySelectorAll('.icons-row--background .icons-row__title').forEach(function (title) {
      title.style.maxWidth = 'none';
      var white = title.style.whiteSpace;
      title.style.whiteSpace = 'nowrap';
      title.style.width = 'max-content';
      var oneLine = title.getBoundingClientRect().width;
      title.style.whiteSpace = white;
      title.style.width = '';
      if (oneLine > 0) title.style.maxWidth = Math.ceil(oneLine / 2 + 24) + 'px';
    });
  }
  if (document.querySelector('.icons-row--background')) {
    var balanceTimer = null;
    var rebalance = function () {
      clearTimeout(balanceTimer);
      balanceTimer = setTimeout(balanceBenefitLabels, 150);
    };
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(rebalance);
    window.addEventListener('load', rebalance);
    window.addEventListener('resize', rebalance);
  }

  function drawer() {
    return window.cart && typeof window.cart.getCart === 'function' ? window.cart : null;
  }

  function refreshAndOpen() {
    var c = drawer();
    if (!c) return;
    if (onCartPage || !c.ajaxEnabled) {
      c.getCart();
      return;
    }
    if (c.cart === null) {
      // First open: renders the drawer template, which also fetches the cart.
      c.openCartDrawer();
      return;
    }
    c.getCart();
    if (!c.cartDrawerIsOpen) c.openCartDrawer();
  }

  var openTimer = null;
  function scheduleOpen() {
    clearTimeout(openTimer);
    openTimer = setTimeout(refreshAndOpen, 150);
  }

  function isAddUrl(url) {
    return typeof url === 'string' && url.indexOf('/cart/add') !== -1;
  }

  // Trade customers keep the wholesale app's "Trade cart" page, as before: only that page
  // shows trade prices. Anything that would open the drawer goes there instead (the app
  // points the header cart link at it), and the drawer helpers below are skipped.
  var c = drawer();
  if (window.scTrade === true) {
    var goToTradeCart = function () {
      var link = document.querySelector('a[href*="/apps/wpdapp/wholesale/wpd-cart"]');
      window.location.href = link ? link.getAttribute('href') : '/cart';
    };
    if (c) {
      c.openCartDrawer = goToTradeCart;
      c.popoverShow = goToTradeCart;
    }
    return;
  }

  // Replace the desktop "added" popover with the drawer.
  if (c && c.ajaxEnabled && !onCartPage) {
    c.popoverShow = function () {
      scheduleOpen();
    };
  }

  // Catch adds made with fetch (theme, quick view, apps).
  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      var method = (init && init.method) || (input && input.method) || 'GET';
      var promise = originalFetch.apply(this, arguments);
      if (isAddUrl(url) && String(method).toUpperCase() === 'POST') {
        promise
          .then(function (response) {
            if (response && response.ok) scheduleOpen();
          })
          .catch(function () {});
      }
      return promise;
    };
  }

  // Catch adds made with XMLHttpRequest (older app scripts).
  var originalOpen = XMLHttpRequest.prototype.open;
  var originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._scMethod = method;
    this._scUrl = url;
    return originalOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (isAddUrl(this._scUrl) && String(this._scMethod).toUpperCase() === 'POST') {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) scheduleOpen();
      });
    }
    return originalSend.apply(this, arguments);
  };

  // In-cart suggestions: one-tap add.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-sc-rec-add]');
    if (!button || button.disabled) return;
    event.preventDefault();

    button.disabled = true;
    button.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
      body: JSON.stringify({
        items: [{id: Number(button.getAttribute('data-variant-id')), quantity: 1, properties: {_source: 'cart-rec'}}],
      }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
          Shopify.analytics.publish('sc_rec_add', {variant_id: button.getAttribute('data-variant-id')});
        }
        // The fetch wrapper above refreshes the drawer.
      })
      .catch(function () {
        button.disabled = false;
        button.classList.remove('is-loading');
      });
  });

  // Gift message and order note inside the drawer (the /cart page keeps its own inline script).
  // Saved as the customer types, so express wallets (which skip the form submit) keep them.
  if (!onCartPage) {
    var noteTimer = null;
    document.addEventListener('input', function (event) {
      var field = event.target;
      if (!field.matches || !field.closest('.cart-drawer')) return;
      var body = null;
      if (field.matches('textarea[name="attributes[Gift Message]"]')) {
        body = {attributes: {'Gift Message': field.value}};
      } else if (field.matches('textarea[name="note"]')) {
        body = {note: field.value};
      }
      if (!body) return;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify(body),
        }).catch(function () {});
      }, 500);
    });
  }

  // Close the panel when the dimmed background is clicked.
  document.addEventListener('click', function (event) {
    var c = drawer();
    if (c && c.cartDrawerIsOpen && event.target.classList && event.target.classList.contains('cart-drawer')) {
      c.closeCartDrawer();
    }
  });

  // "Continue shopping" closes the panel (Modular goes back a page on mobile instead).
  document.addEventListener(
    'click',
    function (event) {
      var link = event.target.closest && event.target.closest('.cart-drawer [data-continue]');
      var c = drawer();
      if (!link || !c || onCartPage) return;
      event.preventDefault();
      event.stopPropagation();
      c.closeCartDrawer();
    },
    true
  );
})();
